import { render, staticRenderFns } from "./AddActivityLabourerWorkplacePage.vue?vue&type=template&id=f0d47ba4&"
import script from "./AddActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./AddActivityLabourerWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports